import Vue from "vue";
import VueI18n from "vue-i18n";
import zh_hans from "@/lang/zh-hans";
import en from "@/lang/en";

Vue.use(VueI18n)


const i18n = new VueI18n({
  locale: "zh-hans",
  messages: {
    "zh-hans": zh_hans,
    "en": en
  }
})

export default i18n
